import { render, staticRenderFns } from "./RecruiterPayments.vue?vue&type=template&id=63bb8c3b&scoped=true&"
import script from "./RecruiterPayments.vue?vue&type=script&lang=js&"
export * from "./RecruiterPayments.vue?vue&type=script&lang=js&"
import style0 from "./RecruiterPayments.vue?vue&type=style&index=0&id=63bb8c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb8c3b",
  null
  
)

export default component.exports